import React, { Dispatch, SetStateAction } from "react";

export interface AnalyticsContextState {
    enabledForEnvironment?: boolean;
    userId?: string;
}

// The argument passed to createContext simply mimics React's useState()
// semantics.
const AnalyticsContext = React.createContext<
    [AnalyticsContextState, Dispatch<SetStateAction<AnalyticsContextState>>]
>([{}, () => {}]);

export default AnalyticsContext;
